import React from "react";


function Identifier({ nodeIdx, status, currentExecution }) {

	return (
		<div className="node-idx">
			{
				!currentExecution
					? <span><small style={{ fontSize: "10px", color: "#b0b0b0" }}>#</small>{nodeIdx}</span>
					: <span
						style={{
							fontSize: "11px",
							padding: "1px 3px",
						}}
					>
						{
							function () {

								// return <i class="fas fa-spinner fa-spin"></i>

								let className = "animate__animated animate__fadeIn ";
								if (status == "AWAITING") className += " fa-clock ";
								else if (status == "OK") className += " fa-check-circle text-success ";
								else if (status == "FAILED") className += " fa-times-circle text-danger ";
								else if (status == "RUNNING") className += " fa-spinner fa-spin text-primary";
								else className += "fa-minus text-muted";

								return <i class={`fas ${className}`}></i>

							}()
						}
					</span>
			}
		</div>
	)

}


export default Identifier;

